import * as yup from 'yup';

export const schema = yup
  .object({
    showStars: yup.boolean(),
    reviewCountLabel: yup.string(),
  })
  .transform(value => ({
    showStars: value.show_stars ?? true,
    reviewCountLabel: value.review_count_label,
  }));
